<template>
  <v-card>
    <v-toolbar dark :color="showMap ? 'gray darken-4' : 'primary'" flat>
      <v-btn icon dark @click="closeSection">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title class="mr-3">Mapas</v-toolbar-title>
      <v-divider v-if="showMap" vertical></v-divider>
      <v-flex v-if="showMap" d-inline-flex align-center ml-3>
        <div style="max-width:190px">
          <v-btn small color="primary darken-1" @click="initData">
            <v-icon left size="16">
              map
            </v-icon>
            Nueva consulta
          </v-btn>
        </div>
        <v-divider vertical></v-divider>
        <!-- MAP TYPE -->
        <div style="max-width:150px" class="ml-3">
          <h4 class="text-xs-right">
            {{
              `Mapa con intervalo de datos ${intervalSelected === 0 ? 'por hora' : 'por día'}`
            }}
          </h4>
        </div>
        <!-- AGENCY -->
        <div style="max-width:150px" class="ml-5">
          <h4>
            <span class="pr-1">Agencia</span><br />
            {{
              agencyName
            }}
          </h4>
        </div>
        <div class="ml-4">
          <span class="pr-1">Periodo de tiempo</span><br />
          {{ metaDataHeatmap.parameters.initial_date | filterDate }}
          {{ metaDataHeatmap.parameters.initial_date | filterTime }}
          al
          {{ metaDataHeatmap.parameters.final_date | filterDate }}
          {{ metaDataHeatmap.parameters.final_date | filterTime }}
        </div>
        <div class="ml-3">
          <span class="pr-1">Datos procesados</span><br />{{ metaDataHeatmap.count }}
        </div>
        <div class="ml-3">
          <span class="pr-1">Mapa generado el</span><br />
          {{ metaDataHeatmap.time | filterDate }}
          {{ metaDataHeatmap.time | filterTime }}
        </div>
      </v-flex>
    </v-toolbar>
    <!-- PRE CONTENT -->
    <div v-if="!showMap" class="pre-content pa-5">
      <h3>Seleccione el día a consultar</h3>
      <!-- DATE INTERVAL FOR DATE1 & DATE2 -->
      <v-flex>
        <v-menu
          lazy
          ref="menu0"
          v-model="menu0"
          transition="scale-transition"
          offset-x
          left
          full-width
          origin="top left"
          nudge-right="300"
          nudge-top="-40"
          color="white"
          :close-on-content-click="false"
          :return-value.sync="dates0"
          :disabled="isGettignHeatmap"
        >
          <template v-slot:activator="{ on }">
            <v-combobox
              v-model="dates0"
              multiple
              chips
              small-chips
              label="Fecha"
              placeholder="Escoger el día a consultar"
              prepend-inner-icon="event"
              readonly
              box
              color="white"
              v-on="on"
            ></v-combobox>
          </template>
          <v-date-picker
            v-model="dates0"
            multiple
            no-title
            scrollable
            :first-day-of-week="1"
            locale="es-sp"
            :allowed-dates="allowedDates0"
            color="blue accent-3"
            @input="changesDate0"
          >
            <v-spacer></v-spacer>
            <v-btn color="error" @click="menu0 = false">Cancelar</v-btn>
            <v-btn color="primary" @click="acceptDate0">Aceptar</v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>
      <h3>Período de tiempo</h3>
      <v-flex>
        <v-radio-group v-model="intervalSelected">
          <v-radio
            v-for="(item, index) in intervalOption"
            color="primary"
            :key="index"
            :label="item"
            :value="index"
            :disabled="isGettignHeatmap"
          ></v-radio>
        </v-radio-group>
      </v-flex>
      <!-- BASE AGENCIES LIST -->
      <div v-if="adminRole !== null">
        <h3>Agencias Base</h3>
        <div  class="caption">*Opcional</div>
        <v-select
          v-model="agencySelected"
          label="Agencias"
          :items="agenciesBaseFiltered"
          item-text="name"
          item-value="id"
          return-object
          box
          clearable
        ></v-select>
      </div>
      <!-- GET MAP BUTTON -->
      <v-flex v-if="!isGettignHeatmap">
        <v-btn
          color="primary"
          block
          :disabled="diseabledGetHeatmap"
          @click="getHeatmap"
        >
          Cargar Mapa
        </v-btn>
      </v-flex>
      <v-flex v-else>
        <v-progress-circular
          :size="48"
          :width="3"
          color="primary"
          indeterminate
        />
      </v-flex>
      <v-alert
        v-model="showMessage"
        type="error"
        color="red darken-1"
        dismissible
        transition="scale-transition">
          Mapa no encontrado con los criterios enviados.
      </v-alert>
    </div>
    <!-- MAPS -->
    <iframe v-else id="heatMapIn"
      title="Heatmap"
      width="100%"
      :src="url"
    ></iframe>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'heat-map',
  data() {
    return {
      url: '',
      showMap: false,
      menu0: false,
      dates0: [],
      day0: '2021-10-31',
      intervalOption: [
        'Por hora',
        'Por día'
      ],
      intervalSelected: null,
      metaDataHeatmap: {
        count: 0,
        parameters: {},
        time: ''
      },
      isGettignHeatmap: false,
      showMessage: false,
      agencySelected: undefined
    }
  },
  computed: {
    ...mapGetters(['agenciesBase', 'agenciesMap']),
    ...mapGetters({
      adminRole: 'auth/adminRole',
      role: 'auth/role'
    }),
    agenciesBaseFiltered() {
      let _agenciesBase = this.agenciesBase
      if (this.adminRole === 400) {
        _agenciesBase = _agenciesBase.filter(item => item.id !== 115)
      }
      return _agenciesBase
    },
    diseabledGetHeatmap() {
      let result = true
      if (this.dates0.length === 1 && this.intervalSelected !== null) result = false
      return result
    },
    agencyName() {
      let _agencyName = ''
      if (this.adminRole === 500 || this.adminRole === 400) {
        _agencyName = this.agencySelected !== undefined ? this.agencySelected.name : 'Todas'
      } else {
        _agencyName = this.agenciesMap.get(this.role[0]).name
      }
      return _agencyName
    }
  },
  methods: {
    ...mapActions(['getDynamicHeatmap', 'getStaticHeatmap']),
    allowedDates0(date) {
      const today = this.$moment.now()
      const yesterday = this.$moment(today).subtract(1, 'day')
      let datesResult = this.$moment(date).isBefore(yesterday) &&
        this.$moment(date).isAfter(this.day0)
      if (this.dates0.length === 1) datesResult = date === this.dates0[0]
      return datesResult
    },
    changesDate0() {
      this.showMessage = false
    },
    acceptDate0() {
      this.$refs.menu0.save(this.dates0)
    },
    initData() {
      this.url = ''
      this.showMap = false
      this.menu0 = false
      this.dates0 = []
      this.intervalSelected = null
      this.metaDataHeatmap = {
        count: 0,
        parameters: {},
        time: ''
      }
      this.isGettignHeatmap = false
      this.showMessage = false
      this.agencySelected = undefined
    },
    closeSection() {
      this.initData()
      this.$emit('close')
    },
    async getHeatmap() {
      if (this.dates0.length === 1 && this.intervalSelected !== null) {
        this.isGettignHeatmap = true
        const payload = {
          date: this.dates0[0]
        }

        if (this.agencySelected !== undefined && (this.adminRole === 500 || this.adminRole === 400)) {
          payload.agencySelected = this.agencySelected.id
        }

        if (this.adminRole === null) {
          payload.agencySelected = this.role[0]
        }

        const result = this.intervalSelected === 0
          ? await this.getDynamicHeatmap(payload)
          : await this.getStaticHeatmap(payload)

        // console.log('RESULT getHeatmap', result)
        // console.log('RESULT url', result.data.url)
        this.isGettignHeatmap = false
        if (result.data.url !== '') {
          this.url = result.data.url
          this.metaDataHeatmap.count = result.data.metaData.count
          this.metaDataHeatmap.parameters = result.data.metaData.parameters
          this.metaDataHeatmap.time = result.data.metaData.time
          this.showMap = true
        } else {
          this.showMessage = true
          // this.initData()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
iframe {
  height: calc(100vh - 70px);
}

span {
  color: #757575;
  font-weight: 500;
}

.pre-content {
  max-width: 390px;
}

</style>



// WEBPACK FOOTER //
// src/components/HeatMap.vue